import { css } from '@emotion/core';
import { colorsPalette, hexToRgba } from '../../../styles/colors';
import { typography, fontWeights } from '../../../styles/typography';
import { MediaQueries } from '../../../styles/Grid';

export const whatwedoteaserbg = css({
  background: '#F4F3F0',
  overflow: 'hidden',
  margin: '128px 0px 0px 0px',
  paddingBottom: '64px',

  [MediaQueries.sm]: {
    margin: '64px 0px 0px 0px',
    paddingBottom: '64px',
  },

  [MediaQueries.md]: {
    margin: '96px 0px 0px',
    paddingBottom: '64px',
  },
  [MediaQueries.lg]: {
    margin: '96px 0px 0px 0px',
    paddingBottom: '64px',
  },

  '.swiper-slide:hover': {
    cursor: 'pointer',
    borderColor: 'transparent',
    boxShadow: '0px 10px 80px rgb(0 0 0 / 8%)',
    outline: '0',
  },
});

export const whatwedoteaser = css({
  paddingBottom: '0px',
  marginTop: '64px',
  marginBottom: '0px',
  [MediaQueries.sm]: {
    marginTop: '64px',
  },
  [MediaQueries.lg]: {
    marginTop: '64px',
  },
  [MediaQueries.md]: {
    marginTop: '64px',
  },

  '.headsec': {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '48px',
    [MediaQueries.sm]: {
      alignItems: 'center',
    },
    h2: {
      color: '#393939',
      fontSize: '48PX',
      lineHeight: '48px',
      fontWeight: '500',
      letterSpacing: '-1px',

      marginTop: 0,

      [MediaQueries.sm]: {
        fontSize: '40px',
        lineHeight: '40px',
        letterSpacing: '-0.3px',
      },
    },

    '.toprightviewsection': {
      'span:first-child': {
        borderBottom: `1px solid ${colorsPalette.red}`,
      },
    },

    a: {
      fontSize: '18px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '32px',
      letterSpacing: '0px',
      textAlign: 'left',
      color: colorsPalette.red,
      textDecoration: 'none',

      i: {
        fontSize: '16px',
        marginLeft: '16px',
        position: 'relative',
        top: '2px',
      },
    },
  },

  '.hr_sec': {
    hr: {
      borderTop: '1px solid #FAD3CC',
    },
  },
});
export const sectionTitle = css({
  color: 'red',

  [MediaQueries.lgAndUp]: {
    h2: {
      color: '#393939',
      fontSize: '48PX',
      lineHeight: '48px',
      fontWeight: '500',
      letterSpacing: '-0.1px',
      marginBottom: 40,
      marginTop: 40,
    },
  },
});

export const goBackButtonContainer = css({
  marginBottom: 48,
});

export const goBackButton = css(typography.effra16, {
  border: 0,
  background: colorsPalette.transparent,
  color: colorsPalette.black,
  display: 'flex',
  alignItems: 'center',
  padding: 0,
  cursor: 'pointer',
});

export const goBackButtonLabel = css({
  marginLeft: 10,
});

export const mainItemstop = css({
  marginBottom: 50,
});

export const mainItems = css({
  color: '#a2a2a2',
  fontSize: '14px',
  lineHeight: '1.75',
  // '.classname': { padding: '10px' },
  a: {
    color: '#393939',
    fontWeight: '600',
    textDecoration: 'none',
    display: 'block',
    fontWeight: '400',
    lineHeight: '40px',
    marginBottom: '16px',
    fontSize: '28px',
    letterSpacing: '-0.4px',
  },
});

export const itemHolder = css({
  marginBottom: 50,
});

export const underline = css({
  borderBottom: '1px solid #D9DBDD',
  marginBottom: '8px',
  display: 'inline-block',
});

export const subItems = css({
  color: '#a2a2a2',
  lineHeight: '1.75',
  a: {
    color: '',
    fontWeight: '500',
    paddingLeft: '5px',
    textDecoration: 'none',
    color: '#393939',
  },
  '.subItems': {
    paddingLeft: '15px',
    fontSize: '14px',
    a: {
      fontWeight: '400',
    },
  },
});
